export default {"src":"/_next/static/media/vip.1f6fce26.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};